export var Mode = {
  REDIRECT: 'redirect',
  EMBED: 'embed',
  MODAL: 'modal'
};
export var AppContext = {
  MY_NERDWALLET: 'my-nerdwallet',
  EXTERNAL: 'external'
};
export var Channel = {
  EMAIL: 'email',
  MOBILE: 'mobile',
  WEB: 'web'
};
export var Element = {
  DEFAULT: 'default',
  BANNER: 'banner',
  BUTTON: 'button',
  HYPERLINK: 'hyperlink',
  AD_UNIT: 'ad-unit',
  FILTER: 'filter',
  APPLICATION: 'application'
};
export var modalClosedBy = {
  USER: 'user',
  APP: 'app',
  SUCCESS: 'success'
};
export var AuthType = {
  SIGNIN: 'signin',
  REGISTER: 'register',
  SUCCESS: 'success'
};
export var AuthProviders = {
  NERDWALLET: 'NERDWALLET',
  GOOGLE: 'GOOGLE',
  APPLE: 'APPLE',
  CORP_IDP: 'CORP_IDP'
};
/**
 * Possible reasons the last 3rd party (Google or Apple) auth action failed.
 * If it's not a reason we care about then it falls to `OTHER`
 */

export var ThirdPartyAuthFailReasons = {
  REQUIRES_PASSWORD: 'requires_password',
  USER_MUST_SET_PASSWORD: 'user_must_set_password',
  PROVIDER_ID_CONFLICT: 'provider_id_conflict',
  POPUP_CLOSED_BY_USER: 'popup_closed_by_user',
  OTHER: 'other'
};
export var APPLE_SIGNIN_POST_MESSAGE_SOURCE = 'APPLE_SIGNIN_POST_MESSAGE_SOURCE';
export { CURRENT_TU_TOS, CURRENT_TU_TOS_VERSION, CURRENT_YODLEE_TOS_VERSION } from "./tos";
export var JS_AUTH_TOOLS_ASYNC_MIDDLEWARE_TYPE = 'JS_AUTH_TOOLS_ASYNC_MIDDLEWARE_TYPE';
export var CreditPurposeList = ['Apply for a credit card', 'Apply for a personal loan', 'Apply for or refinance a mortgage', 'Buy or lease a car', 'Monitor my credit score and report', 'Build credit from scratch', 'Increase my credit score'];
export var stateAbbreviations = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY', 'AS', 'FM', 'GU', 'MH', 'MP', 'PW', 'PR', 'VI'].sort();
export var DATE_FORMAT = {
  // @deprecated The "American" format is deprecated due to brand style updates
  AMERICAN: 'MM/DD/YYYY',
  STANDARD: 'YYYY-MM-DD'
};
export * from "./account-aggregation";
export * from "./credit-score";
export * from "./debt";
export * from "./flows";
export * from "./my-bills";
export * from "./transunion";
export * from "./yodlee";